import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { theme } from '@openx/components-core/lib/theme/theme.ts';
import { useTranslation } from 'react-i18next';

type ClearAllOptionDropdownItemProps = {
  onClear: () => void;
};

export const ClearAllOptionDropdownItem = ({ onClear }: ClearAllOptionDropdownItemProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        ':hover': {
          cursor: 'default',
        },
        alignItems: 'center',
        background: theme.palette.background.boxLight,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 0.8,
        width: '100%',
      }}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Button onClick={onClear} variant="text" color="error" data-test="hierarchy-clear-all">
        {t('Clear all')}
      </Button>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          textTransform: 'uppercase',
        }}
      >
        {t('allow/block')}
      </Typography>
    </Box>
  );
};
